import { useModalStore } from "@/hooks/Modal/hooks";
import { Button } from "antd";
import React from "react";
import CopyOrderInfoSettingModal from "../../../dialogs/CopyOrderInfoSettingModal";

interface CopyOrderInfoSettingButtonProps {}

const CopyOrderInfoSettingButton: React.FC<CopyOrderInfoSettingButtonProps> = function (props) {
    const modalStore = useModalStore();

    return (
        <Button
            style={{ color: "#777" }}
            className="ml5"
            type="link"
            onClick={(e) => {
                e.stopPropagation();

                /** 关闭Dropdown */
                setTimeout(() => {
                    document.dispatchEvent(
                        new MouseEvent("mousedown", {
                            bubbles: true,
                            cancelable: true,
                            view: window,
                        }),
                    );
                }, 0);

                modalStore.openModal(CopyOrderInfoSettingModal);
            }}
        >
            设置
        </Button>
    );
};

export default React.memo(CopyOrderInfoSettingButton);
